<template>
    <div class="list-turma">
        
        
        
        <c-panel>

            <el-form label-position="top" class="u-mb-30">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingProjecao" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="!loading && Object.keys(projecao).length > 0">     

                <div class="table-projecao container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th></th>
                                <th style="width: 200px;" class="u-text-center">TURNO INTEGRAL<br>QTD. TURMAS</th>
                                <th style="width: 200px;" class="u-text-center">TURNO MATUTINO<br>QTD. TURMAS</th>
                                <th style="width: 200px;" class="u-text-center">TURNO VESPERTINO<br>QTD. TURMAS</th>
                                <th style="width: 200px;" class="u-text-center">TURNO NOTURNO<br>QTD. TURMAS</th>
                                <th style="width: 200px;" class="u-text-center">Qtd. Vagas por Turmas</th>
                            </tr>
                        </thead>
                        <tbody>
                                
                            <tr v-for="(curso, i) in projecao" :key="i">
                                <td>
                                    {{ curso.nome }}
                                </td>
                                <td><el-input class="u-text-center" v-model="curso.integral" maxlength="191"></el-input></td>
                                <td><el-input class="u-text-center" v-model="curso.matutino" maxlength="191"></el-input></td>
                                <td><el-input class="u-text-center" v-model="curso.vespertino" maxlength="191"></el-input></td>
                                <td><el-input class="u-text-center" v-model="curso.noturno" maxlength="191"></el-input></td>
                                <td><el-input class="u-text-center" v-model="curso.vagas_por_turma" maxlength="191"></el-input></td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>  

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div class="u-text-right u-mt-15">
                            <el-button type="primary" @click="onSubmitProjecao()">CRIAR TURMAS</el-button>
                        </div>
                    </el-col>
                </el-row>  

            </div>

            <div v-if="loading" class="u-text-center" style="margin-top: 50px; margin-bottom: 50px;">
                <hr>
                    <img class="u-mt-10 u-mb-10" src="/public/img/loading-bar.gif" />
                <hr>
            </div>       
            
            <div v-if="!loading && !filtro.instituicao_id && Object.keys(projecao).length === 0" style="border: 1px solid #ccc; background-color: #f7eaa9;">
                <h4 class="u-text-center">selecione uma instituição</h4>
            </div>
              
        </c-panel>

    </div>
</template>
<script>

export default {
    data: () => ({
        turmaSelected: '',
        loadingInstituicao: false,
        loading: false,
        filtro: {
            instituicao_id: ''
        },
        projecao: []

    }),
    mounted(){

    },
    methods: {        
        loadingProjecao(){

            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getProjecaoByInstituicao/${this.filtro.instituicao_id}`, this.$store.getters.getHeaderAuth).then(response => {

                for(let i in response.data){

                    response.data[i].integral = (response.data[i].integral === 0 ? '' : response.data[i].integral);
                    response.data[i].matutino = (response.data[i].matutino === 0 ? '' : response.data[i].matutino);
                    response.data[i].vespertino = (response.data[i].vespertino === 0 ? '' : response.data[i].vespertino);
                    response.data[i].noturno = (response.data[i].noturno === 0 ? '' : response.data[i].noturno);
                }

                this.projecao = response.data;
                this.loading = false;
            
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitProjecao(){

            this.$msgbox.confirm('Tem certeza que deseja criar turmas?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/gerarTurmasByProjecao/${this.filtro.instituicao_id}`, this.projecao, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.erro !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                    }else{

                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.loadingProjecao();
                    }

                    window.eventBus.$emit('loading', false);
                    

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});            
        }
    },
    components:{  }
}
</script>
<style>

    .table-turmas .table th, .table-turmas .table td {
        padding: 5px 10px;
    }
    
    .list-turma .list-turno{
        padding-left: 0px;
    }

    .titulo-curso{

        background-color: #e8e8e8;
        margin-top: 25px;
        padding: 5px 20px;
        display: block;
    }

    .list-cursos{
        padding-left: 15px;
    }

    .list-turmas{

        margin-top: 10px;
        display: block;        
    }

    .instituicao .container-list-turmas{
        text-transform: uppercase;
    }

    .row-turma{
        border-bottom: 1px solid #ccc;
    }
    

</style>